import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=2fa2b6b8&"
import script from "./Integration.vue?vue&type=script&lang=ts&"
export * from "./Integration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports